import GaugeChart from './GaugeChart.jsx'
import styles from './DiagnosisReport.module.css'

const Section = ({ sectionKey, sectionData }) => (
  <div className={styles.section}>
    <div className={styles.sectionHeader}>
      <h2 className={styles.sectionTitle}>{sectionKey.replace(/_/g, ' ')}</h2>
    </div>
    <div className={styles.sectionContent}>
      <div className={styles.gaugeWrapper}>
        <GaugeChart score={sectionData.score_out_of_10} label={sectionData.dominant_type} />
      </div>
      <div className={styles.recommendations}>
        {Object.entries(sectionData.recommend).map(([title, desc]) => (
          <div key={title} className={styles.recommendationItem}>
            <h4 className={styles.recommendationTitle}>{title.replaceAll('_', ' ')}</h4>
            <p className={styles.recommendationDesc}>{desc}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
)

const DiagnosisReport = ({ result }) => {
  if (!result) return null

  return (
    <div className={styles.container}>
      {Object.entries(result).map(([sectionKey, sectionData]) => (
        <Section key={sectionKey} sectionKey={sectionKey} sectionData={sectionData} />
      ))}
    </div>
  )
}

export default DiagnosisReport
